/*
 * @Author: kongxiangyu
 * @Date: 2022-12-06 17:05:09
 * @LastEditTime: 2023-02-09 15:03:03
 * @email: kongxiangyu@cd.baidu.com
 * @Description: Do not edit
 */
/* eslint-disable */
/**
 * @file share.js
 * @desc 重新定义地图客户端分享到微信或微博的文案
 * @author zhaoziwei
 * @data 2020/12/14
 */
 import {appendParam} from '@baidu/map-fe-utils';

export function homeShare(urlWb) {
    // 防止页面href链接过长，造成微博无法分享，手动拼接分享url
    let url = location.protocol + '//' + location.host + location.pathname + location.search;
    let weChatParam = '';
    let friendParam = '';
    let weiBoParam = '';

    url = url
    weChatParam = {
        title: '情人节1分钱团美食！',
        text: '百度地图甜蜜预售中！',
        pic: 'https://internal-amis-res.cdn.bcebos.com/images/food-valentine-2023-share.png'
    };
    friendParam = {
        text: '情人节1分钱团美食,百度地图甜蜜预售中！',
        pic: 'https://internal-amis-res.cdn.bcebos.com/images/food-valentine-2023-share.png'
    };
    weiBoParam = {
        text: '情人节1分钱团美食,百度地图甜蜜预售中！',
        pic: 'https://internal-amis-res.cdn.bcebos.com/images/food-valentine-2023-share2.png'
    };

    let shareData = [{
        src: 'weixin',
        title: weChatParam.title || '百度地图',
        text: weChatParam.text,
        url:appendParam(urlWb,{fr:'wx'}),
        contentType: 'text',
        pic: weChatParam.pic
    },
    {
        src: 'friend',
        text: friendParam.text,
        url:appendParam(urlWb,{fr:'wx'}),
        contentType: 'text',
        pic: friendParam.pic
    }
    ,
    {
        src: 'weibo',
        text: weiBoParam.text,
        url:appendParam(urlWb,{fr:'weibo'}),
        pic: weiBoParam.pic
    }
    ];
    if (window.yymap && window.yymap.naa) {
        window.yymap.naa.initShare(shareData);
    }
}

/* eslint-enable */
